<template>
    <setting-layout
        :title="$t('pages.user.setting.creator.title')"
        :back="{ name: 'user.own.profile.view' }"
    >
        <v-container class="pt-2 mt-4">
            <div
                v-for="(item, index) in menus"
                :key="index"
                class="link text-decoration-none"
                @click="handleClickItem(item)"
            >
                <v-row class="ml-0 mr-0 item pl-2 mt-3">
                    <v-col cols="2" class="d-flex justify-center align-center ps-0">
                        <icon-cross v-if="item.icon === 'icon-cross'"/>
                        <v-icon v-else-if="item.icon === 'mdi-palm-tree'">mdi-palm-tree</v-icon>
                        <moderator-badge-icon v-else-if="item.icon === 'moderator-badge-icon'"/>
                        <verified-icon v-else-if="item.icon === 'verified-icon'"/>
                        <gifted-subscription-badge-icon v-else-if="item.icon === 'mystery-box'" />
                        <icon-dream-goal v-else-if="item.icon === 'icon-dream-goal'"/>
                        <icon-info v-else-if="item.icon === 'icon-info'"/>
                        <rising-star v-else-if="item.icon === 'rising_stars'" :color="'white'"/>
                        <agreement-icon v-else-if="item.icon === 'agreement-icon'"/>
                        <referral-icon v-else-if="item.icon === 'referral-icon'"/>
                        <app-icon v-else :icon="item.icon" size="21"/>
                    </v-col>
                    <v-col cols="8" class="ps-0">
                        {{ item.text }}
                    </v-col>
                    <v-col cols="2" v-if="!item.locked">
                        <icon-great />
                    </v-col>
                    <v-col cols="2" v-else>
                        <div
                            style="
                                display: flex;
                                height: 100%;
                                align-items: center;
                            "
                        >
                            <icon-locked />
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-container>
        <inform-dialog
            :text="
                !user.verified
                    ? $t('dialogs.unlock_verify_account')
                    : clickedItem.to === 'user.setting.creator.streams'
                    ? $t('dialogs.streams_restricted')
                    : ''
            "
            v-if="showInformDialog"
            @close="handleCloseInformDialog"
        />
    </setting-layout>
</template>

<script>
import SettingLayout from "@/layouts/app/profile/SettingLayout";
import IconLocked from "@/assets/images/icons/locked.svg?inline";
import IconGreat from "@/assets/images/icons/great.svg?inline";
import InformDialog from "@/components/app/dialogs/InformDialog";
import GiftedSubscriptionBadgeIcon from "@/assets/images/icons/gifted-subscription.svg?inline";
import ModeratorBadgeIcon from "@/components/app/icons/ModeratorBadgeIcon";
import IconDreamGoal from "@/assets/images/icons/piggy-bank-noty.svg?inline";
import IconInfo from "@/assets/images/icons/info.svg?inline";
import RisingStar from "@/components/app/icons/RisingStarIcon";
import VerifiedIcon from "@/assets/images/icons/verify-account.svg?inline";
import AgreementIcon from "@/assets/images/icons/agreement.svg?inline";
import ReferralIcon from "@/assets/images/icons/referral.svg?inline";

import { mapState } from "vuex";

export default {
    name: "Creator",
    data: () => ({
        showInformDialog: false,
        clickedItem: null,
    }),
    computed: {
        ...mapState({
            user: (state) => state.user.user.data,
        }),
        menus() {
            return [
                // {text: this.$t('pages.user.setting.creator.verify_yoti.verify_account'), locked: false, to: 'user.setting.creator.verify'},
                // {text: this.$t('pages.user.setting.creator.verify_yoti.title'), locked: false, to: 'user.setting.creator.verifyYoti'},
                {
                    text: this.$t(
                        "pages.user.setting.creator.verify_ondato.title"
                    ),
                    locked: false,
                    to: "user.setting.creator.verifyOndato",
                    icon: "verified-icon",
                },
                {
                    text: this.$t("pages.user.setting.creator.agreement.title"),
                    locked: !this.user.verifyOndatoAt,
                    to: "user.setting.creator.agreement",
                    icon: "agreement-icon",
                },
                {
                    text: this.$t(
                        "pages.user.setting.creator.withdraw_options.title"
                    ),
                    locked: !this.user.verified,
                    to: "user.setting.creator.withdraw",
                    icon: "icon icon-wallet app-icon-white",
                },
                {
                    text: this.$t("pages.user.setting.creator.streams.title"),
                    locked:
                        !this.user.verified || this.user.streams_restricted_at,
                    to: "user.setting.creator.streams",
                    icon: "icon icon-video app-icon-white",
                },
                {
                    text: this.$t(
                        "pages.user.setting.creator.subscriptions.title"
                    ),
                    locked: !this.user.verified,
                    to: "user.setting.creator.subscription",
                    icon: "icon icon-subscribe app-icon-white",
                },
                {
                    text: this.$t("pages.user.setting.creator.holiday_mood.title"),
                    locked: !this.user.verified,
                    to: "user.setting.creator.holiday_mood",
                    icon: "mdi-palm-tree",
                },
                {
                    text: this.$t("pages.user.setting.creator.mystery_box.title"),
                    locked: !this.user.verified,
                    to: "user.setting.creator.mystery_box",
                    icon: "mystery-box",
                },
                {
                    text: this.$t("pages.user.setting.creator.promotion.title"),
                    locked: !this.user.verified,
                    to: "user.setting.creator.promotion",
                    icon: "rising_stars",
                },
                {
                    text: this.$t("pages.user.setting.creator.tip_menu.title"),
                    locked: !this.user.verified,
                    to: "user.setting.creator.tips",
                    icon: "icon icon-dollar app-icon-white",
                },
                {
                    text: this.$t("pages.user.setting.creator.messages.title"),
                    locked: !this.user.verified,
                    to: "user.setting.creator.messages",
                    icon: "icon icon-telegram app-icon-white",
                },
                {
                    text: this.$t("pages.user.setting.creator.moderator.title"),
                    locked: !this.user.verified,
                    to: "user.setting.creator.moderator",
                    icon: "moderator-badge-icon",
                },
                {
                    text: this.$t("pages.user.setting.creator.referrals.title"),
                    locked: !this.user.verified,
                    to: "user.setting.creator.referrals",
                    icon: "referral-icon",
                },
                {
                    text: this.$t("pages.user.setting.creator.dream_goal.title"),
                    locked: !this.user.verified,
                    to: "user.setting.creator.dream_goal",
                    icon: "icon-dream-goal",
                },
            ];
        },
    },
    methods: {
        handleClickItem(item) {
            if (item.locked) {
                this.clickedItem = item;
                this.showInformDialog = true;
                return;
            }

            this.$router.push({ name: item.to });
        },
        handleCloseInformDialog() {
            this.showInformDialog = false;
            this.clickedItem = null;
        },
    },
    mounted() {
        this.$mixpanel.identifyUser(this.user.email);
        this.$mixpanel.pageViewed('Noodzler');
    },
    components: {
        SettingLayout,
        IconLocked,
        IconGreat,
        InformDialog,
        GiftedSubscriptionBadgeIcon,
        ModeratorBadgeIcon,
        IconDreamGoal,
        IconInfo,
        RisingStar,
        VerifiedIcon,
        AgreementIcon,
        ReferralIcon
    },
};
</script>

<style scoped>
.item {
    background: #1a1a1a;
    border-radius: 3px;
}
</style>
